import mixitup from 'mixitup';

$(() => {
  $('#menu-header-menu li.menu-item-has-children').append('<div class="toggle lg:hidden absolute z-20 top-0 right-0 px-2 py-1"><svg class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>');

  var timing = 200;

  $('#menu-header-menu > li.menu-item-has-children > .toggle').click(function() {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  $('#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle').click(function() {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  // Desktop nav
  $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').hover(function() {
    if( $(window).innerWidth() > 991 ) {
      var target = $(this).find('> ul.sub-menu');
      var width = $(target).outerWidth();

      var right_of_screen = $(window).innerWidth();
      var right_of_parent = $(this).offset().left + $(this).outerWidth();
      var right_of_element = right_of_parent + width;

      if (right_of_screen > right_of_element){
        $(target).css('transform', 'translateX(100%)');
        $(target).css('right', '0');
      } else {
        $(target).css('transform', 'translateX(-100%)');
        $(target).css('left', '0');
      }
    }
  });

  $('.slick-banner').on('init', function() {
    var hiddenSlides = $('.slick-banner .hidden');
    if(hiddenSlides.length > 1) {
      $('.slick-banner .hidden').each(function(i, el) {
        $(el).removeClass('hidden');
      })
    } else {
      hiddenSlides.removeClass('hidden');
    }
  })

  // Hero Banner Slider
  $(document).ready(function() {
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;

    if(!isMobile) {
      setInterval(function() {
        let firstEl = $('#hero_banner').children('.hero_banner-image:first-child');
        firstEl.remove();
        $('#hero_banner').append(firstEl);
        }, 3500);
    }

  });



  // Smooth Scroll
  $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();

      $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top - 200,
      }, 500);
  });

  // Offcanvas
  $(window).scroll(function() {
    if ($(document).scrollTop() > 100) {
      $('.offcanvas-cta').addClass('offcanvas-show')
    } else {
      $('.sticky-nav').removeClass('offcanvas-show')
    }
  });

  $('.offcanvas-cta').hover(
    function(){
      $(this).removeClass('offcanvas-minimise');
    }, function() {
      $(this).addClass('offcanvas-minimise');
    }
  );


  // Slick
  $('.slick-banner').slick({
    dots: false,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });

  $('.slick-p').click(function() {
    $(this).parent().prev().slick('slickPrev');
  });
  $('.slick-n').click(function() {
    $(this).parent().prev().slick('slickNext');
  });

  // Mixitup
  if( $('.mix-container').length ) {
    let mixer;
    if ( window.location.pathname == '/' ){
      mixer = mixitup('.mix-container', {
        load: {
        filter: '.aluminium',
        },
      })
    } else {
      mixer = mixitup('.mix-container');
    }
  }

  // Cookie Policy
  $.fn.CookieNotice = function() {
    if (!localStorage.getItem('cookie-notice-dismissed')) {
      var notice = this;
      setTimeout(function() {
        notice.addClass('active');
      }, 1000);
    }
    this.addClass('cookie-notice');
    return this
  }
  $(document).on('click', '.cookie-notice-dismiss', function() {
    localStorage.setItem('cookie-notice-dismissed', true);
    $(this).parents('.cookie-notice').removeClass('active');
  })
  $('#cookie-notice').CookieNotice();

  // Share Button
  $('.page-share').click(function() {
    if( navigator.share ) {
      navigator.share({
        title: 'Share This Page',
        url: window.location,
      }).then(() => {
        console.log('Thanks for sharing!');
      })
      .catch(err => {
        console.log('Couldnt share because of', err.message);
      });
    } else {
      $('#panel-share').toggleClass('active');
      console.log('navigator.share not supported!')
    }
  });

  $('.panel-share-close').click(function() {
    $('#panel-share').removeClass('active');
  });

  // Mobile Nav
  $('#nav-primary-toggle').click(function() {
    $('.nav-primary').toggleClass('open');
    $('.nav-backdrop').toggleClass('show');
  });
});

// Landing Page Gallery Slider
$('.slick-gallery-landing').slick({
  dots: false,
  infinite: false,
  slidesToShow: 2,
  autoplay: true,
  slidesToScroll: 1,
  draggable: true,
  centerMode: false,
});

// Testimonials Slider
$('.testimonials-slider').slick({
  arrows: true,
  dots: false,
  cssEase: 'ease-in-out',
  slidesToShow: 1,
  slidestoScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 1000,
  infinite: true,
  prevArrow: $(".slick-p"),
  nextArrow: $(".slick-n"),
});

  $('.slick-p').click(function() {
    $(this).parent().prev().slick('slickPrev');
  });
  $('.slick-n').click(function() {
    $(this).parent().prev().slick('slickNext');
  });

  // Related Product Slider

  $('.related-products-slider').slick({
  arrows: true,
  dots: false,
  cssEase: 'ease-in-out',
  slidesToShow: 4.5,
  slidestoScroll: 1,
  infinite: false,
  prevArrow: $(".slick-p"),
  nextArrow: $(".slick-n"),
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1.5,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$('.product-p').click(function() {
  $(this).parent().prev().slick('slickPrev');
});
$('.product-n').click(function() {
  $(this).parent().prev().slick('slickNext');
});

// Product Range Slider

  $('.product-range-slider').slick({
  arrows: true,
  dots: false,
  cssEase: 'ease-in-out',
  slidesToShow: 4,
  slidestoScroll: 1,
  infinite: false,
  prevArrow: $(".prod-slide-p"),
  nextArrow: $(".prod-slide-n"),
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1.5,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$('.prod-slide-p').click(function() {
  $(this).parent().prev().slick('slickPrev');
});
$('.prod-slide-n').click(function() {
  $(this).parent().prev().slick('slickNext');
});

// Gallery Slider

$('.gallery-slider').slick({
  arrows: true,
  dots: false,
  cssEase: 'ease-in-out',
  slidesToShow: 3,
  slidestoScroll: 1,
  infinite: false,
  prevArrow: $(".slide-p"),
  nextArrow: $(".slide-n"),
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

// Simple Fading Slider (e.g. showroom images)
$('.slick-fade').slick({
  arrows: false,
  dots: false,
  cssEase: 'ease-in-out',
  slidesToShow: 1,
  slidestoScroll: 1,
  infinite: true,
  fade: true,
  autoplay: true,
  autoplaySpeed: 1000,
});

$('.slide-p').click(function() {
  $(this).parent().prev().slick('slickPrev');
});
$('.slide-n').click(function() {
  $(this).parent().prev().slick('slickNext');
});


// Chatbot
function loadScript( url, callback ) {
  return null;  var script = document.createElement( 'script' )
    script.type = 'text/javascript';
    if(script.readyState) {  // only required for IE <9
      script.onreadystatechange = function() {
        if ( script.readyState === 'loaded' || script.readyState === 'complete' ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {  //Others
      script.onload = function() {
        callback();
      };
    }  script.src = url;
    document.getElementsByTagName( 'head' )[0].appendChild( script );
  }

  var loadChat = function() {
    window.removeEventListener('scroll', loadChat);
    loadScript('//widget.manychat.com/bob.js', function() {
   return null;   var showChat = setInterval(function (){
          if(document.querySelector('.fb_reset')) {
            document.querySelector('.fb_reset').style.display = 'block';
            clearInterval(showChat);
          }
        }, 2000)
    });
  }

  function manyScript( url ) {
    var script = document.createElement( 'script' )
    script.type = 'text/javascript';
    script.src = url;

    document.getElementsByTagName( 'footer' )[0].appendChild( script );
  }

  var loadResponseIq = function() {
    window.removeEventListener('scroll', loadResponseIq);

    manyScript('https://mccdn.me/assets/js/widget.js');
  }

  window.addEventListener('scroll', loadResponseIq)

  window.addEventListener('scroll', loadChat)
